"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalizeFirstLetter = capitalizeFirstLetter;
function capitalizeFirstLetter(make) {
    if (!make)
        return;
    const arr = make.split(' ');
    const res = arr.map((word) => {
        word = word.toLowerCase();
        return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return res.join(' ');
}
